'use client';
import { Box } from '@mui/material';
import { Providers } from './providers';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang='en' style={{ height: '100%', overflow: 'hidden' }}>
      <body style={{ margin: 0, height: '100%', overflow: 'hidden' }}>
        <Providers>
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              width: '100%',
              overflow: 'hidden',
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            {children}
          </Box>
        </Providers>
      </body>
    </html>
  );
}
